import { faArrowUpAZ, faArrowUpZA, faSearch, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { useSelectable } from 'hooks/useSelectable';
import useDebounce from 'hooks/useDebounce';
import { getCoaches, deleteCoaches } from '@redux/features/coachesSlice';
import { addNotification } from '@redux/features/notificationsSlice';
import { SelectionInfo } from 'components/SelectionInfo';
import { NoResults } from 'components/NoResults';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { CreateCoach } from 'pages/Database/Coaches/CreateCoach';
import { CoachCard } from 'pages/Database/Coaches/CoachCard';
import { PageSelector } from '../PageSelector';
import mainStyles from 'pages/Database/Database.scss';
import styles from 'pages/Database/Coaches/Coaches.scss';

export const Coaches = () => {
  const { isLoading, coaches } = useSelector((state) => state.coaches);
  const { selectedIDs, toggleSelection, clearSelection } = useSelectable();
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortAsc, setSortAsc] = useState(true);
  const dispatch = useDispatch();

  const debouncedSearchQuery = useDebounce(searchQuery, 400);

  useEffect(() => {
    dispatch(getCoaches(debouncedSearchQuery));
  }, [debouncedSearchQuery]);

  const handleDelete = async () => {
    if (selectedIDs.length > 0) {
      const result = await dispatch(deleteCoaches(selectedIDs));

      if (result.meta.requestStatus === 'fulfilled') {
        dispatch(
          addNotification({
            id: Date.now(),
            title: 'Тренери успішно видалені',
            type: 'success',
          })
        );
        toggleSelectMode();
      }
    }
  };

  const sortedCoaches = [...coaches].sort((a, b) => {
    const surnameCompare = a.surname.localeCompare(b.surname);
    if (surnameCompare !== 0) return sortAsc ? surnameCompare : -surnameCompare;
    const nameCompare = a.name.localeCompare(b.name);
    return sortAsc ? nameCompare : -nameCompare;
  });

  const toggleSelectMode = () => {
    setIsSelectionMode(!isSelectionMode);

    if (isSelectionMode) {
      clearSelection();
    }
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <h1>
            <FontAwesomeIcon icon={faUsers} />
            База даних
          </h1>
          <p>Огляд клієнтів, тренерів та груп</p>
        </div>
        <PageSelector />
        <div className={styles.buttons}>
          <SelectionInfo
            selectedItems={selectedIDs}
            wordForms={['тренера', 'тренери', 'тренерів']}
            isSelectionMode={isSelectionMode}
          />
          <Button
            text={isSelectionMode ? 'Відміна' : 'Виділити'}
            onClick={toggleSelectMode}
            ghostStyle={isSelectionMode}
          />
          <Button text='Видалити' onClick={handleDelete} disabled={selectedIDs.length === 0} />
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.search}>
          <Input
            placeholder="Прізвище або ім'я"
            icon={faSearch}
            value={searchQuery}
            onChange={({ target }) => setSearchQuery(target.value)}
          />
          <button className={styles.sortBtn} onClick={() => setSortAsc(!sortAsc)}>
            <FontAwesomeIcon icon={sortAsc ? faArrowUpAZ : faArrowUpZA} />
          </button>
        </div>
        <CreateCoach />
      </div>
      {sortedCoaches.length > 0 ? (
        <ul className={cn(mainStyles.table, styles.coaches)}>
          {sortedCoaches.map((coach) => (
            <CoachCard
              coach={coach}
              isSelected={selectedIDs.includes(coach.id)}
              isSelectionMode={isSelectionMode}
              toggleSelection={toggleSelection}
              key={coach.id}
            />
          ))}
        </ul>
      ) : (
        !isLoading && <NoResults />
      )}
    </>
  );
};
